import React from 'react'

const Manual_metodo_pago_manual_descripcion = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl text-4xl text-[#002D33] mb-5">
          Método de pago manual con descripción
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Aprende cómo configurar un método de pago manual con descripción personalizada dentro de Clau.io.
        </p>
        <iframe
          src="https://scribehow.com/embed/Metodo_de_pago_manual_con_descripcion__nXSzMLU4RJGd-fpKeRLiMQ?as=scrollable"
          className="scribe-iframe-general-107"
          width="100%"
          height="5200"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_metodo_pago_manual_descripcion
